import { IReports } from "@/androidPlugins/IReports"
import type { RetrieveZReportResponse } from "./retrieveZReport"

const { formatToMerchantCurrencyString } = useCurrency()

/**
 * Used to generate a receipt from a TerminalZRead object that doesen't have a receipt attribute set.
 *
 * This will be the case for any TerminalZRead objects generated on versions < 2.2.0.
 *
 * Since we don't know anything about this object (what app version it was generated with, what acquirer it was for etc) we presume any key may be null.
 */
export const formatPartialZReport = async (
  report: RetrieveZReportResponse
) => {
  const { name, address1, address2 } = useTenant()
  const { serialNumber, platform } = useDevice()

  const reportMid =
    platform === "paxEvo"
      ? (await IReports.getReportMerchantId()).value
      : null

  return (
    getDataLine(name.value, null, true) +
    getBlankLines(1) +
    (address1.value ? address1.value + "\n" : "") +
    (address2.value ? address2.value + "\n" : "") +
    getDataLine(serialNumber.value, "S/N") +
    getDataLine(reportMid, "MID") +
    (report.headerFields
      ? Object.keys(report.headerFields).reduce(
          (currentHeaderString, key) =>
            currentHeaderString +
            getDataLine(report.headerFields![key], key),
          ""
        )
      : getDataLine(
          report.createdAt.toLocaleDateString(),
          "Date"
        ) +
        getDataLine(
          report.createdAt.toLocaleTimeString(),
          "Time"
        )) +
    getBlankLines(1) +
    getDataLine(report.fromReceiptNo, "From receipt no") +
    getDataLine(report.toReceiptNo, "To receipt no") +
    getBlankLines(1) +
    "SUMMARY: \n" +
    getBlankLines(1) +
    getPartialZReportLine(
      "Sales",
      report.saleCount,
      report.saleAmount
    ) +
    getPartialZReportLine(
      "Voids",
      report.voidCount,
      report.voidAmount
    ) +
    getPartialZReportLine(
      "CASHBACK",
      report.cashbackCount,

      report.cashbackAmount
    ) +
    getPartialZReportLine(
      "Tips",
      report.gratuityCount,

      report.gratuityAmount
    ) +
    getPartialZReportLine(
      "Refunds",
      report.refundCount,

      report.refundAmount
    ) +
    getPartialZReportLine(
      "Completions",
      report.completionCount,

      report.completionAmount
    ) +
    getPartialZReportLine(
      "TOTAL",
      report.totalCount,
      report.totalAmount
    ) +
    getBlankLines(1) +
    getPartialZReportLine(
      "Pre-Auth",
      report.preAuthCount,

      report.preAuthAmount
    ) +
    getPartialZReportLine(
      "Pre-Auth TopUp",
      report.preAuthTopUpCount,

      report.preAuthTopUpAmount
    ) +
    getPartialZReportLine(
      "Pre-Auth Voids",
      report.preAuthCancelledCount,

      report.preAuthCancelledAmount
    )
  )
}

const getPartialZReportLine = (
  label: string,
  count: number | null,
  amount: number | null
) => {
  if (count === null || amount == null) {
    return "" // Better to present no information than partial information
  }

  return getDoubleDataLine(
    label,
    count.toString(),
    formatToMerchantCurrencyString(amount)
  )
}
